/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var emptyObject = {};
var _default = function _default(columns) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyObject,
    showWarnings = _ref.showWarnings;
  return columns.reduce(function (acc, col) {
    if (col.id) {
      if (showWarnings && acc[col.id]) {
        console.error("Duplicate column with id \"".concat(col.id, "\" found!"));
      }
      acc[col.id] = col;
    }
    if (col.name && col.name != col.id) {
      if (showWarnings && !col.id && acc[col.name]) {
        console.error("Duplicate column with name \"".concat(col.name, "\" found!"));
      }
      if (!col.id) {
        acc[col.name] = col;
      }
    }
    if (typeof col.groupBy == 'string' || col.groupByName) {
      var key = col.groupBy || col.groupByName;
      acc[key] = col;
    }
    return acc;
  }, {});
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/mapColumns.js
// module id = 224
// module chunks = 0